import * as React from 'react';
import './TrackerTypesPage.scss';

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as TrackerTypeActions from '../../../actions/trackerTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { QALookupsLayout } from '../../index';

interface ITrackerTypesPageProps {

    location: Location;
    history: History;

    // From state
    formFilter: IFormFilter;
    trackerTypes: Dtos.TrackerType[];
    loadingTrackerTypes: boolean;
    loadTrackerTypesSuccess: boolean;
    loadTrackerTypesFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];
}

interface ITrackerTypesPageActions {
    clearTrackerTypes: TrackerTypeActions.ITrackerTypeClearActionCreator;
    loadTrackerTypes: TrackerTypeActions.ITrackerTypeLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: TrackerTypeActions.ITrackerTypeFilterActionCreator;
}

type TrackerTypesPageProps = ITrackerTypesPageProps & ITrackerTypesPageActions;

class TrackerTypesPage extends React.PureComponent<TrackerTypesPageProps, any> {

    constructor(props: TrackerTypesPageProps) {
        super(props);

        this.clearTrackerTypes = this.clearTrackerTypes.bind(this);
    }

    componentDidMount() {
        const {
            loadTrackerTypes
        } = this.props;

        loadTrackerTypes();
    }

    componentWillReceiveProps(nextProps: TrackerTypesPageProps) {
    }

    componentDidUpdate(prevProps: TrackerTypesPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: TrackerTypesPageProps) {
    }

    componentWillUnmount() {
        this.clearTrackerTypes();
    }

    clearTrackerTypes() {
        this.props.clearTrackerTypes();
    }

    showTrackerTypes(): boolean {
        const {
            loadingTrackerTypes,
            loadTrackerTypesSuccess
        } = this.props

        if (!loadingTrackerTypes && loadTrackerTypesSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingTrackerTypes
        } = this.props;

        return <QALookupsLayout loading={loadingTrackerTypes} permission={Dtos.Permission.TaskTypesView}>
            {this.renderContent()}
        </QALookupsLayout>;
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Tracker Types</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e) } />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TaskTypesCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/qa/trackerTypes/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showTrackerTypes() ?
                    "Loading TrackerTypes" :
                    null
            }
            {
                this.showTrackerTypes() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            trackerTypes
        } = this.props

        if (!trackerTypes || trackerTypes.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no trackerTypes to view.</span>
            </div>
        }

        const showPagination = trackerTypes.length > DEFAULT_PAGE_SIZE;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={trackerTypes}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : trackerTypes.length}
                pageSize={showPagination ? undefined : trackerTypes.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no trackerType to display"
                resizable={false}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/settings/qa/trackerTypes/" + rowInfo.original.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        },
                        style: {
                            color: (rowInfo && rowInfo.original && rowInfo.original.active) ? '#212529' : '#9e9e9e'
                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "value",
                        Header: 'Name',
                        accessor: 'value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: TrackerTypesPageProps): ITrackerTypesPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: state.routing.location,

        formFilter: state.trackerTypes.formFilter,
        trackerTypes: state.trackerTypes.formFilteredData, 

        loadingTrackerTypes: state.trackerTypes.loadState && state.trackerTypes.loadState.status == RequestState.Pending,
        loadTrackerTypesSuccess: state.trackerTypes.loadState && state.trackerTypes.loadState.status == RequestState.Success,
        loadTrackerTypesFailure: state.trackerTypes.loadState && state.trackerTypes.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles
    };
};

const mapDispatchToProps = (dispatch): ITrackerTypesPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadTrackerTypes: bindActionCreators(TrackerTypeActions.LoadTrackerType, dispatch),
        clearTrackerTypes: bindActionCreators(TrackerTypeActions.Clear, dispatch),

        filter: bindActionCreators(TrackerTypeActions.Filter, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TrackerTypesPage);
